import { fetchAccessToken, logout } from "../../../services/auth";
import useRequest from "../useRequest";
import useAdaptedData from "../../useAdaptedData";
import { IGeneralError } from "../types";
import { adaptOnboardingInfo } from "./adapters";
import { BOnboardingInfo } from "./types";
import LocalStorage from "../../../services/LocalStorage";
import { HttpMethod } from "../../../types/http";

export const useOnboardingInfo = (
  params: {
    userId?: number | null;
    viewerUserId?: number | null;
    username?: string | null;
  } | null
) => {
  const { data, ...rest } = useRequest<BOnboardingInfo, IGeneralError>(
    params && (params.userId || params.username)
      ? {
          method: HttpMethod.PUT,
          url: "/whoami/user/onboarding-info/",
          data: {
            userId: params.userId,
            username: params.username,
            reqType: params.userId ? "id" : "username",
            ...(params.viewerUserId && { viewerId: params.viewerUserId }),
          },
        }
      : null,
    {
      shouldRetryOnError: true,
      onErrorRetry: async (error, key, config, revalidate, { retryCount }) => {
        if (error.status !== 401) return;
        if (retryCount >= 3) {
          logout();
          return;
        }
        const { accessToken } = await fetchAccessToken();
        LocalStorage.setAuth(accessToken, "");
        setTimeout(() => {
          revalidate({ retryCount });
        }, 1000);
      },
    }
  );

  const isUnauthorized = rest.error?.response?.status === 401;
  const isDeletedUser =
    rest.error?.response?.status === 400 &&
    !!rest.error?.response?.data?.errors?.find((error) =>
      /The requested instance of cosmos user given the queryset of: {'pk': [0-9].*} doesn't exist/.test(
        error.message
      )
    );

  if (isUnauthorized || isDeletedUser) {
    logout();
  }

  return {
    ...rest,
    data: useAdaptedData({ data, adapter: adaptOnboardingInfo }),
  };
};
